<template>
  <InputDecimal
    ref="InputDecimal"
    :model-value="valueObject"
    :read-only="readOnly"
    :min="min"
    :fraction-min="0"
    :fraction-max="99"
    :placeholder="placeholder"
    fraction-placeholder="00"
    :disabled="disabled"
    :required="required"
    :data-test-prefix="dataTestPrefix"
    @update:model-value="update"
  >
    <template #before-integer>
      <span class="input-group-addon">
        <slot name="input-label">
          {{ currency.toUpperCase() }}
        </slot>
      </span>
    </template>
  </InputDecimal>
</template>

<script>
import { nextTick } from 'vue'
import InputDecimal from '@/components/InputDecimal.vue'

/**
 * We can use v-model on an object of format { integer: 0, fraction: 0 }
 * or if you prefer to use cents, use <input-currency :cents.sync="centValue">
 */
export default {
  components: {
    InputDecimal,
  },
  props: {
    modelValue: { type: Object, default: () => ({ integer: 0, fraction: 0 }) },
    cents: { type: Number, default: 0 },
    currency: { type: String, default: 'DKK', required: false },
    decimalPoint: {
      type: String,
      default: this?.account?.locale === 'da' ? ',' : '.',
    },
    required: { type: Boolean, default: false },
    readOnly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    min: { type: Number, default: 0 },
    dataTestPrefix: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'update:cents'],
  computed: {
    valueObject() {
      return this.cents ? this.centsToObject(this.cents) : this.modelValue
    },
  },
  methods: {
    update(valueObject) {
      this.$emit('update:modelValue', valueObject)
      this.$emit('update:cents', this.asCents(valueObject))
    },
    asCents(valueObject) {
      return Number(`${valueObject.integer}${valueObject.fraction}`)
    },
    centsToObject(cents) {
      const valueString = (cents / 100).toFixed(2)
      return {
        integer: valueString.slice(0, -3),
        fraction: valueString.slice(-2),
      }
    },
    focus() {
      nextTick(() => this.$refs.InputDecimal.focus?.())
    },
  },
}
</script>
